var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "px-0 py-0", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "align-center", attrs: { "no-gutters": "" } },
        [
          _c("img", {
            staticClass: "mr-3",
            attrs: {
              src: require("@/assets/icon-ticket.svg"),
              width: "40px",
              height: "40px"
            }
          }),
          _c("div", { staticClass: "title-header" }, [
            _vm._v("Tickets gestionados en los últimos 12 meses")
          ]),
          _c("v-spacer"),
          _vm.$can(_vm.createAction, _vm.pdtResourceName) ||
          _vm.$can(_vm.createAction, _vm.remoteHandsResourceName) ||
          _vm.$can(_vm.createAction, _vm.ticketsResourceName)
            ? _c(
                "v-btn",
                {
                  attrs: { color: "green", dark: "" },
                  on: {
                    click: function() {
                      return this$1.$refs.modal.openModal()
                    }
                  }
                },
                [_vm._v("Crear Ticket")]
              )
            : _vm._e()
        ],
        1
      ),
      _c("TicketCreateModal", { ref: "modal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }